import React from "react";
import { Line } from "react-chartjs-2";
import { ReactifyChartColors } from "Util/ReactifyChartColors";

const colors = ReactifyChartColors();

const chartData = {
  labels: ["January", "February", "March", "April", "May", "June", "July"],
  datasets: [
    {
      label: "Sales Each Month",
      fill: false,
      lineTension: 0.1,
      backgroundColor: colors.ReactifyChartColor1,
      borderColor: colors.ReactifyChartColor1,
      borderDash: [],
      borderDashOffset: 0.0,
      pointBorderColor: colors.ReactifyChartColor1,
      pointBackgroundColor: colors.ReactifyChartColor1,
      pointBorderWidth: 5,
      pointHoverRadius: 5,
      pointHoverBackgroundColor: colors.ReactifyChartColor1,
      pointHoverBorderColor: colors.ReactifyChartColor1,
      pointHoverBorderWidth: 2,
      pointRadius: 1,
      pointHitRadius: 10,
      data: [40, 59, 80, 72, 56, 90, 40]
    }
  ]
};

function LineChart() {
  return (
    <div>
      <Line data={chartData} />
    </div>
  );
}

export default LineChart;
